var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.2946 6.71641H8.59241V2.01417C8.59241 1.80632 8.50984 1.60698 8.36287 1.46001C8.2159 1.31304 8.01656 1.23047 7.80871 1.23047C7.60085 1.23047 7.40152 1.31304 7.25454 1.46001C7.10757 1.60698 7.025 1.80632 7.025 2.01417V6.71641H2.32277C2.11492 6.71641 1.91558 6.79898 1.7686 6.94595C1.62163 7.09292 1.53906 7.29226 1.53906 7.50011C1.53906 7.70796 1.62163 7.9073 1.7686 8.05427C1.91558 8.20125 2.11492 8.28382 2.32277 8.28382H7.025V12.986C7.025 13.1939 7.10757 13.3932 7.25454 13.5402C7.40152 13.6872 7.60085 13.7698 7.80871 13.7698C8.01656 13.7698 8.2159 13.6872 8.36287 13.5402C8.50984 13.3932 8.59241 13.1939 8.59241 12.986V8.28382H13.2946C13.5025 8.28382 13.7018 8.20125 13.8488 8.05427C13.9958 7.9073 14.0783 7.70796 14.0783 7.50011C14.0783 7.29226 13.9958 7.09292 13.8488 6.94595C13.7018 6.79898 13.5025 6.71641 13.2946 6.71641Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 1.56741
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlus);
export default __webpack_public_path__ + "static/media/plus.b315b8cac343e12480cfb7e5d8864aea.svg";
export { ForwardRef as ReactComponent };